import { split } from '@apollo/client/link/core/split.js';
import { getMainDefinition } from '@apollo/client/utilities/index.js';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions/index.js';
import { createClient } from 'graphql-ws';
import { WebSocketLink } from '@apollo/client/link/ws/index.js';
/** helper function to load the websocket graphql uri */
export function getGraphQLWsUri(graphWsUri) {
    if (graphWsUri) {
        return graphWsUri;
    }
    if (typeof window !== 'undefined') {
        // default
        return `${window.location.protocol.replace('http', 'ws')}//${window.location.host}/api/graphql`;
    }
    // if using the link not in a browser a valid WS uri must be provided
    throw new Error('A server side apollo websocket link requires a valid URI.');
}
export const createWsHttpLink = (httpLink, webSocketUri, wsClientOptions, webSocketLinkConfig, protocol = 'subscriptions-transport-ws') => {
    const defaultClientOptions = {
        url: getGraphQLWsUri(webSocketUri),
        lazy: true
    };
    const clientOptions = { ...defaultClientOptions, ...wsClientOptions };
    const subscriptionLink = protocol === 'subscriptions-transport-ws'
        ? new WebSocketLink({
            uri: getGraphQLWsUri(webSocketUri),
            options: {
                reconnect: true,
                lazy: true
            },
            ...webSocketLinkConfig
        })
        : new GraphQLWsLink(createClient(clientOptions));
    return split(({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
    }, subscriptionLink, httpLink);
};
//# sourceMappingURL=createWsHttpLink.js.map